import type { MissionsManager } from "@rescuetablet/missions-client";

// All providers share one MissionsManager. Authorizations run strictly one after another, so the
// most recently requested key always ends up active — an older, slower authorization (e.g. still
// with the previous portal's key) can no longer finish last and leave the app with a foreign
// Missions user and its permissions.
let authorizeQueue: Promise<unknown> = Promise.resolve();

export function authorizeInOrder(
  manager: Pick<MissionsManager, "authorize">,
  missionApiKey: string,
) {
  const run = authorizeQueue.then(() => manager.authorize(missionApiKey));
  authorizeQueue = run.catch(() => undefined);
  return run;
}
